import { createApi } from "@reduxjs/toolkit/query/react";
import { IUser } from "Models/User";
import { setUserLogged } from "redux/features/loggedUserSlice";
import customFetchBase from "./customFetchBase";

export const loggedUserApi = createApi({
  reducerPath: "loggedUserApi",
  baseQuery: customFetchBase,
  tagTypes: ["LoggedUsers"],
  endpoints: (builder) => ({
    getMe: builder.query<IUser, null>({
      query() {
        return {
          url: "users/me",
          credentials: "include",
        };
      },
      transformResponse: (result: { data: IUser }) => {
        return result.data;
      },
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setUserLogged(data));
        } catch (error) {
          // Manejar el error si es necesario
        }
      },
    }),
  }),
});

export const { useGetMeQuery } = loggedUserApi;
